import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'ark-discover-card',
  templateUrl: './discover-card.component.html',
  styleUrls: ['./discover-card.component.css'],
})
export class DiscoverCardComponent {
  @Input() item: any;
  @Input() type: 'problem' | 'idea' | 'solution' | 'thinktank' = 'idea';

  @Output() cardClicked = new EventEmitter<any>();
  @Output() nicknameClicked = new EventEmitter<{ item: any; event: Event }>();

  get isIdea(): boolean {
    return this.type === 'idea';
  }

  get isProblem(): boolean {
    return this.type === 'problem';
  }

  get typeLabel(): string {
    if (this.isIdea) {
      return 'IDEA';
    }

    if (this.isProblem) {
      return 'PROBLEM';
    }

    return this.item?.type === 'thinkTank'
      ? 'Think Tank'
      : this.item?.isDraft === true
        ? 'Draft Solution'
        : 'Solution';
  }

  get identifier(): string | number | null {
    if (this.isIdea) {
      return this.item?.ideaId ?? null;
    }

    if (this.isProblem) {
      return this.item?.problemId ?? null;
    }

    return this.item?.incrementalIdentifier ?? null;
  }

  get contentText(): string {
    return this.isIdea || this.isProblem ? this.item?.description : this.item?.teaser;
  }

  get moderationText(): string {
    if (this.isIdea) {
      return 'IDEA in moderation';
    }

    if (this.isProblem) {
      return 'PROBLEM in moderation';
    }

    return `${this.item?.type === 'thinkTank' ? 'Think Tank' : 'Solution'} in moderation`;
  }

  onCardClick() {
    this.cardClicked.emit(this.item);
  }

  onNicknameClick(event: Event) {
    event.preventDefault();
    event.stopPropagation();
    this.nicknameClicked.emit({ item: this.item, event });
  }
}
